import React from "react";
import IconBase from "./IconBase";
import icon from "./close.svg";

export default function IconClose({ width, height }) {
  return <IconBase alt="schliessen" img={icon} width={width} height={height} />;
}
